import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

// https://observablehq.com/@d3/color-legend@704
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject || (_templateObject = _taggedTemplateLiteral(["# Color Legend\n\nA simple legend for a [color scale](/@d3/color-schemes). Supports [continuous](/@d3/continuous-scales), [sequential](/@d3/sequential-scales), [diverging](/@d3/diverging-scales), [quantize, quantile, threshold](/@d3/quantile-quantize-and-threshold-scales) and [ordinal](/@d3/d3-scaleordinal) scales. To use:\n\n~~~js\nimport {legend, swatches} from \"@d3/color-legend\"\n~~~\n\nThen call the legend function as shown below. (For ordinal scales, also consider the swatches function.)"])));
  });
  main.variable(observer()).define(["legend", "d3"], function (legend, d3) {
    return legend({
      color: d3.scaleSequential([0, 100], d3.interpolateViridis),
      title: "Temperature (°F)"
    });
  });
  main.variable(observer()).define(["legend", "d3"], function (legend, d3) {
    return legend({
      color: d3.scaleSequentialSqrt([0, 1], d3.interpolateTurbo),
      title: "Speed (kts)"
    });
  });
  main.variable(observer()).define(["legend", "d3"], function (legend, d3) {
    return legend({
      color: d3.scaleDiverging([-0.1, 0, 0.1], d3.interpolatePiYG),
      title: "Daily change",
      tickFormat: "+%"
    });
  });
  main.variable(observer()).define(["legend", "d3"], function (legend, d3) {
    return legend({
      color: d3.scaleDivergingSqrt([-0.1, 0, 0.1], d3.interpolateRdBu),
      title: "Daily change",
      tickFormat: "+%"
    });
  });
  main.variable(observer()).define(["legend", "d3"], function (legend, d3) {
    return legend({
      color: d3.scaleSequentialLog([1, 100], d3.interpolateBlues),
      title: "Energy (joules)",
      ticks: 10,
      tickFormat: ".0s"
    });
  });
  main.variable(observer()).define(["legend", "d3"], function (legend, d3) {
    return legend({
      color: d3.scaleSequentialQuantile(Array.from({
        length: 100
      }, function () {
        return Math.pow(Math.random(), 2);
      }), d3.interpolateBlues),
      title: "Quantile",
      tickFormat: ".2f"
    });
  });
  main.variable(observer()).define(["legend", "d3"], function (legend, d3) {
    return legend({
      color: d3.scaleSqrt([-100, 0, 100], ["blue", "white", "red"]),
      title: "Temperature (°C)"
    });
  });
  main.variable(observer()).define(["legend", "d3"], function (legend, d3) {
    return legend({
      color: d3.scaleQuantize([1, 10], d3.schemePurples[9]),
      title: "Unemployment rate (%)"
    });
  });
  main.variable(observer()).define(["legend", "d3"], function (legend, d3) {
    return legend({
      color: d3.scaleQuantile(d3.range(1000).map(d3.randomNormal(100, 20)), d3.schemeSpectral[9]),
      title: "Height (cm)",
      tickFormat: ".0f"
    });
  });
  main.variable(observer()).define(["legend", "d3"], function (legend, d3) {
    return legend({
      color: d3.scaleThreshold([2.5, 3.1, 3.5, 3.9, 6, 7, 8, 9.5], d3.schemeRdBu[9]),
      title: "Unemployment rate (%)",
      tickSize: 0
    });
  });
  main.variable(observer()).define(["legend", "d3"], function (legend, d3) {
    return legend({
      color: d3.scaleOrdinal(["<10", "10-19", "20-29", "30-39", "40-49", "50-59", "60-69", "70-79", "≥80"], d3.schemeSpectral[10]),
      title: "Age (years)",
      tickSize: 0
    });
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["But wait, there\u2019s more!\n\nHow about swatches for ordinal color scales? Both variable-width swatches and [column layout](https://developer.mozilla.org/en-US/docs/Web/CSS/columns) are supported."])));
  });
  main.variable(observer()).define(["swatches", "d3"], function (swatches, d3) {
    return swatches({
      color: d3.scaleOrdinal(["blueberries", "oranges", "apples"], d3.schemeCategory10)
    });
  });
  main.variable(observer()).define(["swatches", "d3"], function (swatches, d3) {
    return swatches({
      color: d3.scaleOrdinal(["Wholesale and Retail Trade", "Manufacturing", "Leisure and hospitality", "Business services", "Construction", "Education and Health", "Government", "Finance", "Self-employed", "Other"], d3.schemeTableau10),
      columns: "180px"
    });
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["---\n\n## Implementation"])));
  });
  main.variable(observer("legend")).define("legend", ["d3", "ramp"], function (d3, ramp) {
    return function legend() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          color = _ref.color,
          title = _ref.title,
          _ref$tickSize = _ref.tickSize,
          tickSize = _ref$tickSize === void 0 ? 6 : _ref$tickSize,
          _ref$width = _ref.width,
          width = _ref$width === void 0 ? 320 : _ref$width,
          _ref$height = _ref.height,
          height = _ref$height === void 0 ? 44 + tickSize : _ref$height,
          _ref$marginTop = _ref.marginTop,
          marginTop = _ref$marginTop === void 0 ? 18 : _ref$marginTop,
          _ref$marginRight = _ref.marginRight,
          marginRight = _ref$marginRight === void 0 ? 0 : _ref$marginRight,
          _ref$marginBottom = _ref.marginBottom,
          marginBottom = _ref$marginBottom === void 0 ? 16 + tickSize : _ref$marginBottom,
          _ref$marginLeft = _ref.marginLeft,
          marginLeft = _ref$marginLeft === void 0 ? 0 : _ref$marginLeft,
          _ref$ticks = _ref.ticks,
          ticks = _ref$ticks === void 0 ? width / 64 : _ref$ticks,
          tickFormat = _ref.tickFormat,
          tickValues = _ref.tickValues;

      var svg = d3.create("svg").attr("width", width).attr("height", height).attr("viewBox", [0, 0, width, height]).style("overflow", "visible").style("display", "block");

      var tickAdjust = function tickAdjust(g) {
        return g.selectAll(".tick line").attr("y1", marginTop + marginBottom - height);
      };

      var x; // Continuous

      if (color.interpolate) {
        var n = Math.min(color.domain().length, color.range().length);
        x = color.copy().rangeRound(d3.quantize(d3.interpolate(marginLeft, width - marginRight), n));
        svg.append("image").attr("x", marginLeft).attr("y", marginTop).attr("width", width - marginLeft - marginRight).attr("height", height - marginTop - marginBottom).attr("preserveAspectRatio", "none").attr("xlink:href", ramp(color.copy().domain(d3.quantize(d3.interpolate(0, 1), n))).toDataURL());
      } // Sequential
      else if (color.interpolator) {
        x = Object.assign(color.copy().interpolator(d3.interpolateRound(marginLeft, width - marginRight)), {
          range: function range() {
            return [marginLeft, width - marginRight];
          }
        });
        svg.append("image").attr("x", marginLeft).attr("y", marginTop).attr("width", width - marginLeft - marginRight).attr("height", height - marginTop - marginBottom).attr("preserveAspectRatio", "none").attr("xlink:href", ramp(color.interpolator()).toDataURL()); // scaleSequentialQuantile doesn’t implement ticks or tickFormat.

        if (!x.ticks) {
          if (tickValues === undefined) {
            var _n = Math.round(ticks + 1);

            tickValues = d3.range(_n).map(function (i) {
              return d3.quantile(color.domain(), i / (_n - 1));
            });
          }

          if (typeof tickFormat !== "function") {
            tickFormat = d3.format(tickFormat === undefined ? ",f" : tickFormat);
          }
        }
      } // Threshold
      else if (color.invertExtent) {
        var thresholds = color.thresholds ? color.thresholds() // scaleQuantize
        : color.quantiles ? color.quantiles() // scaleQuantile
        : color.domain(); // scaleThreshold

        var thresholdFormat = tickFormat === undefined ? function (d) {
          return d;
        } : typeof tickFormat === "string" ? d3.format(tickFormat) : tickFormat;
        x = d3.scaleLinear().domain([-1, color.range().length - 1]).rangeRound([marginLeft, width - marginRight]);
        svg.append("g").selectAll("rect").data(color.range()).join("rect").attr("x", function (d, i) {
          return x(i - 1);
        }).attr("y", marginTop).attr("width", function (d, i) {
          return x(i) - x(i - 1);
        }).attr("height", height - marginTop - marginBottom).attr("fill", function (d) {
          return d;
        });
        tickValues = d3.range(thresholds.length);

        tickFormat = function tickFormat(i) {
          return thresholdFormat(thresholds[i], i);
        };
      } // Ordinal
      else {
        x = d3.scaleBand().domain(color.domain()).rangeRound([marginLeft, width - marginRight]);
        svg.append("g").selectAll("rect").data(color.domain()).join("rect").attr("x", x).attr("y", marginTop).attr("width", Math.max(0, x.bandwidth() - 1)).attr("height", height - marginTop - marginBottom).attr("fill", color);

        tickAdjust = function tickAdjust() {};
      }

      svg.append("g").attr("transform", "translate(0,".concat(height - marginBottom, ")")).call(d3.axisBottom(x).ticks(ticks, typeof tickFormat === "string" ? tickFormat : undefined).tickFormat(typeof tickFormat === "function" ? tickFormat : undefined).tickSize(tickSize).tickValues(tickValues)).call(tickAdjust).call(function (g) {
        return g.select(".domain").remove();
      }).call(function (g) {
        return g.append("text").attr("x", marginLeft).attr("y", marginTop + marginBottom - height - 6).attr("fill", "currentColor").attr("text-anchor", "start").attr("font-weight", "bold").attr("class", "title").text(title);
      });
      return svg.node();
    };
  });
  main.variable(observer("swatches")).define("swatches", ["DOM", "html", "entity"], function (DOM, html, entity) {
    return function swatches(_ref2) {
      var color = _ref2.color,
          _ref2$columns = _ref2.columns,
          columns = _ref2$columns === void 0 ? null : _ref2$columns,
          _ref2$format = _ref2.format,
          format = _ref2$format === void 0 ? function (x) {
        return x;
      } : _ref2$format,
          _ref2$swatchSize = _ref2.swatchSize,
          swatchSize = _ref2$swatchSize === void 0 ? 15 : _ref2$swatchSize,
          _ref2$swatchWidth = _ref2.swatchWidth,
          swatchWidth = _ref2$swatchWidth === void 0 ? swatchSize : _ref2$swatchWidth,
          _ref2$swatchHeight = _ref2.swatchHeight,
          swatchHeight = _ref2$swatchHeight === void 0 ? swatchSize : _ref2$swatchHeight,
          _ref2$marginLeft = _ref2.marginLeft,
          marginLeft = _ref2$marginLeft === void 0 ? 0 : _ref2$marginLeft;
      var id = DOM.uid().id;
      if (columns !== null) return html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<div style=\"display: flex; align-items: center; margin-left: ", "px; min-height: 33px; font: 10px sans-serif;\">\n  <style>\n\n.", "-item {\n  break-inside: avoid;\n  display: flex;\n  align-items: center;\n  padding-bottom: 1px;\n}\n\n.", "-label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: calc(100% - ", "px - 0.5em);\n}\n\n.", "-swatch {\n  width: ", "px;\n  height: ", "px;\n  margin: 0 0.5em 0 0;\n}\n\n  </style>\n  <div style=\"width: 100%; columns: ", ";\">", "\n  </div>\n</div>"])), +marginLeft, id, id, +swatchWidth, id, +swatchWidth, +swatchHeight, columns, color.domain().map(function (value) {
        var label = format(value);
        return html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<div class=\"", "-item\">\n      <div class=\"", "-swatch\" style=\"background:", ";\"></div>\n      <div class=\"", "-label\" title=\"", "\">", "</div>\n    </div>"])), id, id, color(value), id, label.replace(/["&]/g, entity), document.createTextNode(label));
      }));
      return html(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["<div style=\"display: flex; align-items: center; min-height: 33px; margin-left: ", "px; font: 10px sans-serif;\">\n  <style>\n\n.", " {\n  display: inline-flex;\n  align-items: center;\n  margin-right: 1em;\n}\n\n.", "::before {\n  content: \"\";\n  width: ", "px;\n  height: ", "px;\n  margin-right: 0.5em;\n  background: var(--color);\n}\n\n  </style>\n  <div>", "</div>"])), +marginLeft, id, id, +swatchWidth, +swatchHeight, color.domain().map(function (value) {
        return html(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["<span class=\"", "\" style=\"--color: ", "\">", "</span>"])), id, color(value), document.createTextNode(format(value)));
      }));
    };
  });
  main.variable(observer("entity")).define("entity", function () {
    return function entity(character) {
      return "&#".concat(character.charCodeAt(0).toString(), ";");
    };
  });
  main.variable(observer("ramp")).define("ramp", ["DOM"], function (DOM) {
    return function ramp(color) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 256;
      var canvas = DOM.canvas(n, 1);
      var context = canvas.getContext("2d");

      for (var i = 0; i < n; ++i) {
        context.fillStyle = color(i / (n - 1));
        context.fillRect(i, 0, 1, 1);
      }

      return canvas;
    };
  });
  return main;
}